import * as types from './types'
import SiteResource from '@/common/resources/Site'

export const actions = {
	[types.GET_CURRENT_SITE] (context) {
		return new Promise((resolve, reject) => {
			SiteResource.getCurrentSite()
				.then(({ data }) => {
					context.commit(types.SET_CURRENT_SITE, data)
					resolve(data)
				})
				.catch(({ response }) => {
					console.log(response)
					context.commit(types.CLEAR_CURRENT_SITE)
					reject(response.data)
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Site/actions.js